import axios from "axios";
import authHeader from "./authHeader";

const GetAllDocuments = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_EC2_CMS_ENDPOINT}api/MediaUpload/GetAllDocuments`,
      {
        headers: {
          "Content-Type": "application/json",
          ...authHeader(),
        },
      }
    );
    return res.data; ;
  } catch (error) {
    return error;
  }
};


const DeletePDF = async (data: any) => {
  try {
    const response = await axios.post(process.env.REACT_APP_BASE_CMS_ENDPOINT + `api/POI/DeletePDF`, data, {
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },

    });
    return response;
  } catch (error) {
    return error;
  }
};


const PDFUpload = async (
  data: any,
  onUploadProgress: (progress: number) => void
) => {
  try {
    const formData = new FormData();

    // ✅ Correct field name and File object
    formData.append("File", data.File, data.File.name);

    const response = await axios.post(
      `${process.env.REACT_APP_EC2_CMS_ENDPOINT}api/MediaUpload/UploadPDF`,
      formData,
      {
        headers: {
          ...authHeader(),
          // ❌ Don't set Content-Type manually — axios will handle the boundary
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            onUploadProgress(percentCompleted);
          } else {
            onUploadProgress(100);
          }
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error uploading PDF:", error);
    throw error;
  }
};

const DocumentService ={ 
  GetAllDocuments,
  DeletePDF,
  PDFUpload,
};
export default DocumentService;
